<template>
  <el-card shadow="never" class="activeTrend-card echarts-box">
    <h4>活动趋势</h4>
    <div style="display:flex">
      <el-select
        v-model="activeName"
        style="width: 260px"
        multiple
        :multiple-limit="5"
        @change="nameChange"
        placeholder="请选择">
        <el-option
          v-for="item in typeOptions"
          :key="item.code"
          :label="item.desc"
          :value="item.code"
          >
        </el-option>
      </el-select>
      <el-checkbox-group v-if ="activeName.length && baseData.timeType!==0 && baseData.timeType!==1" :disabled="baseData.timeType === -1" v-model="type" style="margin-left: 20px; display: inline-block" @change="typeChange">
        <el-checkbox-button :label="2">环比</el-checkbox-button>
        <el-checkbox-button :label="1">同比</el-checkbox-button>
      </el-checkbox-group>
    </div>
    <div v-if="activeName.length && activeTrend && activeTrend.itemDate.length" id="activeTrend"></div>
    <NoData v-else errTitle="暂无数据" setHeight="280px"></NoData>
  </el-card>
</template>
<script>
import echarts from 'echarts'
import NoData from "@/components/base/no-data"
import { yuanUnit } from '../config'
import { trendTarget, getActiveTrend } from '@/api/marketPromotion/activeData'
export default {
  components: {NoData},
  props: {
    baseData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      typeOptions: [],
      activeName: [],
      type: [],
      colorList: ['#3377FF', '#FFAC52', '#ADCD40', '#FF5D5D', '#67BFFF'],
      typeNameList: ['items'],
      echartsDom: null,
      activeTrend: null
    }
  },
  methods: {
    initEchart(){
      let params = Object.assign({}, this.baseData)
      params.trendTarget = this.activeName.join(',')
      this.getActiveTrend(params)
    },
    init () {
      this.type = []
      this.activeTrend = null
      let params = Object.assign({}, this.baseData)
      this.trendTarget(params)
    },
    nameChange () {
      this.$track.clickEvent('营销推广-营销数据-活动趋势-选择指标', '1627641855')
      if (this.activeName.length) this.initEchart()
    },
    typeChange () {
      if(this.type.length > 1) this.type.shift()
      this.$track.clickEvent('营销推广-营销数据-活动趋势', '1627641856', { tysj_trade_type: this.type[0] == 1 ? 2 : 1})
      this.$nextTick(() => this.drawLine(this.activeTrend))
    },
    drawLine (data) {
      if (!data) return
      this.echartsDom = null
      this.echartsDom = echarts.init(document.getElementById('activeTrend'))
      // x 轴判断
      let xLabel = data.itemDate
      if (data.itemDate.length && data.itemDate[0].split(' ').length !== 1) {
        xLabel = data.itemDate.map(item => item.split(' ')[1])
      }
      // 图例
      let legendList = data.items.map(item => item.trendDesc)
      // 数据处理
      let seriesList = []
      // 同比环比判断
      if (this.type.length){
        let name = this.type[0] === 1 ? 'sameCompareItems' : 'cycleCompareItems'
        if (data[name]) this.typeNameList[1] = name
      } else {
        this.typeNameList = ['items']
      }
      // 判断左右y轴
      let hasPercentage = data.items.some(item => item.trendUnit === '%')
      // 坐标轴单位
      let yFormatterL = '{value}'  
      let yFormatterR = '{value}%'
      this.typeNameList.forEach(typeName => {
        if (data[typeName].length === 1){
          data[typeName][0].yMark = 0
          if (data[typeName][0].trendUnit === '%') yFormatterL = '{value}%' 
        } else if(hasPercentage){
          data[typeName].forEach(item => {item.yMark = item.trendUnit === '%' ? 1 : 0})
        } else {
          yFormatterR = '{value}'
          let list = data[typeName].map(item => {
            return {
              name: item.trendDesc,
              data: Math.max(...item.trendData),
              maxLength: Math.max(...item.trendData).toString().split('.')[0].length
            }
          })
          list = list.sort((a, b) => {
            return b.maxLength - a.maxLength
          })
          if(list.every(item => item.maxLength === list[0].maxLength)) {
            data[typeName].forEach (item => { item.yMark = 0 })
          } else if(data[typeName].length <= 2) {
            data[typeName].forEach((item,i) => {item.yMark = i})
          } else {
            let arr = data[typeName].length === 3 ? [list[0].name] : [list[0].name, list[1].name]
            data[typeName].forEach(item => {
              if (arr.includes(item.trendDesc)){
                item.yMark = 0
              } else {
                item.yMark = 1
              }
            })
          }
        }
        // 数据处理
        data[typeName].forEach((item, i) => {
          let trendData = item.trendUnit === '%' ? item.trendData.map(item => Math.round(Number(item) * 10000)/100) : item.trendData
          seriesList.push({
            name:item.trendDesc,
            data: trendData,
            type: 'line',
            smooth: true,
            yAxisIndex: item.yMark,
            lineStyle: {
              color: this.colorList[i],
              opacity: typeName === 'items' ? 1 : 0.4
            },
            itemStyle: {
              color: this.colorList[i],
              opacity: typeName === 'items' ? 1 : 0.4
            }
          })
        })
      })
      this.echartsDom.setOption({
        color: this.colorList,
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          axisPointer: {
            lineStyle: {
              type: 'dashed'
            },
            type: 'cross',
            label: {
              show: false
            }
          },
          textStyle: {
            color: '#606266'
          },
          formatter: (param) => {
            let html = `<p style="margin:5px 0"><b>${data.itemDate[param[0].dataIndex]}</b></p>`
            let index = this.typeNameList.length >1 ? param.length/2-1 : param.length-1
            param.forEach((item, i) =>{
              if (i <= index) {
              let nullFlag = !data.items[i].nullData[item.dataIndex]
              html += `
                <span style="display:inline-block;width:10px;height:10px;border-radius:5px;border:2px solid ${item.color};margin-right:5px"></span>
                <span>${item.seriesName}：${nullFlag ? yuanUnit(item.data) : '-'} ${data.items[i].trendUnit}</span></br>
              `
              } else {
                let name = this.type[0] === 1 ? 'sameCompare' : 'cycleCompare'
                let nullFlag = !data[name + 'Items'][item.seriesIndex%(param.length/2)].nullData[item.dataIndex]
                if (i === index + 1){
                  html += `<p style="margin:8px 0 5px 0"><b>${data[name + 'Date'][param[0].dataIndex]}</b></p>`
                }
                html += `
                  <span style="display:inline-block;width:10px;height:10px;border-radius:5px;border:2px solid ${item.color};margin-right:5px;opacity:0.4"></span>
                  <span>${item.seriesName}：${nullFlag ? yuanUnit(item.data) : '-'} ${data[name + 'Items'][item.seriesIndex%(param.length/2)].trendUnit}</span></br>
                `
              }
            })
            return html
          },
          padding: [10,16],
          extraCssText: 'box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)'
        },
        xAxis: {
          type: 'category',
          data: xLabel,
          nameTextStyle: {
            color:'#666'
          },
           axisLine: {
            lineStyle: {
              color:'#EAEAEA'
            }
          },
          axisLabel: {
            color:'#666'
          },
          axisTick: {
            show: false
          }
        },
        legend: {
          data: legendList,
          right: '4%'
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                type:'dashed',
                color:'#EAEAEA'
              }
            },
            axisLabel: {
              formatter: yFormatterL
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false
            }
          },
          {
            axisLabel: {
              formatter: yFormatterR
            },
            splitLine: {
              lineStyle: {
                type:'dashed',
                color:'#EAEAEA'
              }
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: seriesList
      }, true)
    },
    async getActiveTrend (params) {
      try {
        const { code, result } = await getActiveTrend(params)
        if (code !== 200) return
        this.activeTrend = result
        this.$nextTick(() => this.drawLine(this.activeTrend))
      } catch (error) {
        console.log(error)
      }
    },
    async trendTarget (params) {
      try {
        const { code, result } = await trendTarget(params)
        this.typeOptions = result || []
        if (code !== 200) return
        if(this.baseData.activityType === 2) {
          this.activeName = ['joinUserNum', 'usedCouUserNum']
        } else {
          this.activeName = ['income', 'costAmount']
        }
        this.initEchart()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../mixin.less');
/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner{
  color: #409EFF;
  background-color: #fff;
  border-color: #409EFF !important;
  box-shadow: -1px 0 0 0 #409eff;
}
/deep/.el-checkbox-button.is-focus .el-checkbox-button__inner{
  border-color: #DCDFE6; 
}
</style>